import { giphyLightCharcoal } from '@giphy/colors'
import React, { useCallback, useState } from 'react'
import styled, { keyframes } from 'styled-components'
import { IconComponent } from 'ui'
import CreationToolUploadField from '../../../types/upload-field'
import { UploadFieldBlock } from '../../blocks'
import Title from './field-title'

type Props = {
    className?: string
    field: CreationToolUploadField
    renderAsUploadFieldBlock?: boolean
    defaultCollapsed?: boolean
    children: React.ReactNode
    titleSuffix?: string
}

const fadeIn = keyframes`
    0% { opacity: 0; }
    100% { opacity: 1; }
`

const Carot = styled(IconComponent)`
    margin: 0 0 0 8px;
    opacity: 0.5;
    transition: opacity 0.1s ease-out;
`

const TitleWrapper = styled.div`
    cursor: pointer;
    display: inline-block;
    user-select: none;
    &:hover ${Carot} {
        opacity: 1;
    }
`

const Wrapper = styled.div`
    animation: ${fadeIn} 0.15s ease-out;
    padding-top: 10px;
`

const CollapsibleField = ({
    className,
    field,
    children,
    defaultCollapsed = false,
    renderAsUploadFieldBlock,
    titleSuffix,
}: Props) => {
    const [isOpen, setIsOpen] = useState(!defaultCollapsed)
    const Component = renderAsUploadFieldBlock ? UploadFieldBlock : 'div'

    const toggleCollapse = useCallback(() => {
        setIsOpen((prevState) => !prevState)
    }, [])

    return (
        <Component className={className}>
            <TitleWrapper onClick={() => toggleCollapse()}>
                <Title field={field}>
                    {titleSuffix}
                    <Carot
                        color={giphyLightCharcoal}
                        height={16}
                        icon={isOpen ? 'navigate-up' : 'navigate-down'}
                        width={16}
                    />
                </Title>
            </TitleWrapper>
            {isOpen && <Wrapper>{children}</Wrapper>}
        </Component>
    )
}

export default CollapsibleField
